import React, {useContext} from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import IsMobileContext from "../../context/isMobile/isMobileContext";

export default function Title(props) {
  const isMobile = useContext(IsMobileContext);
  const { isMobileUse } = isMobile;
  return (
    <>
    {isMobileUse() ?
      <Typography component="h2" variant="subtitle2" style={{color:"#4f4f4f"}} gutterBottom>
        {props.children}
      </Typography>
      :
      <Typography component="h2" variant="h6" style={{color:"#4f4f4f"}} gutterBottom>
        {props.children}
      </Typography>}
    </>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};
